import React, { useState } from 'react';
import BaseCard from '../../components/base/BaseCard';
import ForexMetricsCard from './components/ForexMetricsCard';
import ExtrapolationMatrix from '../calculator/components/matrix/ExtrapolationMatrix';
import ForexSettingsModal from './components/ForexSettingsModal';
import ForexHeader from './components/ForexHeader';
import { useForexCalculator } from './hooks/useForexCalculator.ts';
import { useViewMode } from '../../hooks/useViewMode';

const ForexCalculator = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [focusField, setFocusField] = useState(null);
  const [viewMode, setViewMode] = useViewMode();
  const {
    values,
    setValues,
    metrics,
    pairSpec,
    validationErrors = {},
    isCalculating = false,
    extremePriceField
  } = useForexCalculator();

  const handleOpenSettings = (field = null) => {
    setFocusField(field);
    setModalIsOpen(true);
  };

  return (
    <div className="flex justify-center pt-0 px-3 sm:px-6 pb-6">
      <div className="w-full max-w-5xl space-y-4">
        <BaseCard>
          <ForexHeader
            values={values}
            setValues={setValues}
            pairSpec={pairSpec}
            onOpenSettings={handleOpenSettings}
            errors={validationErrors}
            isCalculating={isCalculating}
            extremePriceField={extremePriceField}
          />
        </BaseCard>

        <ForexMetricsCard
          metrics={metrics}
          pairSpec={pairSpec}
          entryPrice={values.entryPrice}
          values={values}
          isLoading={isCalculating}
          viewMode={viewMode}
        />

        <ExtrapolationMatrix
          positionType={metrics.positionType}
          nominalRR={values.nominalRR}
          effectiveRR={values.nominalRR}
          risk={values.risk}
          accountBalance={values.accountBalance}
          disabled={isCalculating || Object.keys(validationErrors).length > 0}
        />

        <ForexSettingsModal
          isOpen={modalIsOpen}
          onClose={() => {
            setModalIsOpen(false);
            setFocusField(null);
          }}
          values={values}
          setValues={setValues}
          errors={validationErrors}
          initialFocusField={focusField}
          viewMode={viewMode}
          onViewModeChange={setViewMode}
          metrics={metrics}
        />
      </div>
    </div>
  );
};

export default ForexCalculator;
